import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Flex,
  Form,
  Layout,
  TableColumnsType,
  TableProps,
} from "antd";
import {
  ChangeEvent,
  KeyboardEvent,
  useEffect,
  useMemo,
  useState,
} from "react";

import { useNavigate, useParams } from "react-router-dom";

import { ArrowLeftOutlined } from "@ant-design/icons";

import { FormInstance } from "antd/lib";
import { isEmpty } from "lodash";
import PageHeader from "../../../../../components/page-header/PageHeader";
import TableData from "../../../../../components/table-data/TableData";
import {
  getAllCourseInfo,
  getLearningTrendAllIndustry,
  getLearningTrendReportAllUniversity,
} from "../../../../../service/prediction-model";
import FormFilter from "./components/filter-group/FormFilter";
import FilterTable from "./components/filter-table/FilterTable";

type InfoCourseListProps = {
  title?: string;
};

const InfoCourseList = ({ title }: InfoCourseListProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [documentSystem, setDocumentSystem] = useState<any[]>([]);
  const [dataFilter, setDataFilter] = useState({
    university: [],
    is_free: -1,
    industry: [],
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>("");
  const [checkedList, setCheckedList] = useState<any>([]);
  const [listVisible, setListVisible] = useState<any>([]);
  const [optionSelectIndustry, setOptionSelectIndustry] = useState([]);
  const [optionSelectSchool, setOptionSelectSchool] = useState([]);
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("asc");

  const dataColumnsInfoCourse: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 5,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    // {
    //   title: t("Mã khoá học", "Mã khoá học"),
    //   dataIndex: "code",
    //   key: "code",
    //   width: 15,
    // },
    {
      title: t("Tên khoá học", "Tên khoá học"),
      dataIndex: "name",
      key: "name",
      width: 25,
      render: (_: any, record) => {
        return (
          <Flex className="table-order-course-name">
            <img
              className=""
              loading="eager"
              alt=""
              src={record?.image || "/images/ic_school_placeholder.svg"}
            />
            <div className="pl-2">
              <span className="course-title">{record?.name}</span>
            </div>
          </Flex>
        );
      },
      sorter: true,
    },
    {
      title: t("Trường chủ trì", "Trường chủ trì"),
      dataIndex: "university",
      key: "university",
      render: (_: any, record: any) => {
        return <div>{record?.university}</div>;
      },
      width: 10,
    },
    {
      title: t("Chi phí", "Chi phí"),
      dataIndex: "is_free",
      key: "is_free",
      render: (_: any, record: any) => {
        return <div>{record?.is_free ? t("Tính phí", "Tính phí") : t("Miễn phí", "Miễn phí")}</div>;
      },
      width: 10,
    },
    {
      title: t("Khoa môn học", "Khoa môn học"),
      dataIndex: "industry",
      key: "industry",
      render: (_: any, record: any) => {
        return <div>{record?.industry?.join(", ")}</div>;
      },
      width: 20,
    },
  ];
  const keysCheck = dataColumnsInfoCourse.map((item) => item.key);
  const fetchData = async (searchParam: any) => {
    try {
      setLoading(true);
      const response = await getAllCourseInfo(searchParam);
      const { data } = response.data;
      setDocumentSystem(data?.data);

      const defaultCheckedList = keysCheck.filter((key) =>
        data?.data?.some((obj: any) => Object.keys(obj).includes(key as any))
      );
      if (isEmpty(checkedList) || isEmpty(listVisible)) {
        setCheckedList([...defaultCheckedList, "numericalOrder"]);
        setListVisible([...defaultCheckedList, "numericalOrder"]);
      }
      setTotalPage(data?.total?._count?.id);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchListTagUniversity = async () => {
    try {
      const responseUniversity = await getLearningTrendReportAllUniversity(
        params?.id || ""
      );
      const { data: dataUniversity } = responseUniversity.data;

      setOptionSelectSchool(
        dataUniversity?.map((tag: any) => ({
          label: tag?.name,
          value: tag?.id,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  const fetchListTagIndustry = async () => {
    try {
      const response = await getLearningTrendAllIndustry(params?.id || "");
      const { data } = response.data;

      setOptionSelectIndustry(
        data?.map((tag: any) => ({
          label: tag?.name,
          value: tag?.id,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const isFree =
      dataFilter?.is_free === 0 || dataFilter?.is_free === 1
        ? dataFilter?.is_free === 1
          ? false
          : true
        : null;
    fetchData({
      ...dataFilter,
      is_free: isFree,
      name: searchValue,
      take: pageSize,
      skip: (pageNumber - 1) * pageSize,
      sort: fieldSortOrder,
    });
    fetchListTagIndustry();
    fetchListTagUniversity();
  }, [pageSize, pageNumber, fieldSortOrder]);

  const columnChecked = useMemo(() => {
    return dataColumnsInfoCourse.map((item) => ({
      ...item,
      hidden: !checkedList.includes(item.key as string),
    }));
  }, [checkedList]);

  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
    }
  };

  const handleSearch = async (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      const searchParam = {
        ...dataFilter,
        is_free:
          dataFilter?.is_free === 0 || dataFilter?.is_free === 1
            ? dataFilter?.is_free === 1
              ? false
              : true
            : null,
        take: 10,
        skip: 0,
        name: searchValue,
        sort: fieldSortOrder,
      };
      setPageNumber(1);
      fetchData(searchParam);
    }
  };

  const handleSubmitSearch = () => {
    const searchParam = {
      ...dataFilter,
      is_free:
        dataFilter?.is_free === 0 || dataFilter?.is_free === 1
          ? dataFilter?.is_free === 1
            ? false
            : true
          : null,
      take: 10,
      skip: 0,
      name: searchValue,
      sort: fieldSortOrder,
    };
    setPageNumber(1);
    fetchData(searchParam);
  };

  const clearFilter = async (formInstance: FormInstance) => {
    setLoading(true);
    setDataFilter({
      university: [],
      is_free: -1,
      industry: [],
    });
    const searchParam = {
      university: [],
      is_free: null,
      industry: [],
      take: 10,
      skip: 0,
      name: searchValue,
      sort: fieldSortOrder,
    };
    setPageNumber(1);
    fetchData(searchParam);
    formInstance.resetFields();
  };

  const handleFinish = (values: any) => {
    setLoading(true);

    const valueFilter = {
      university: values?.university || [],
      is_free:
        values?.is_free === 0 || values?.is_free === 1
          ? values?.is_free === 1
            ? false
            : true
          : null,
      industry: values?.industry || [],
    };

    const searchParam = {
      ...valueFilter,
      is_free:
        values?.is_free === 0 || values?.is_free === 1
          ? values?.is_free === 1
            ? false
            : true
          : null,
      take: 10,
      skip: 0,
      name: searchValue,
      sort: fieldSortOrder,
    };
    setPageNumber(1);
    fetchData(searchParam);
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter?.order === "ascend"
        ? "asc"
        : sorter?.order === "descend"
        ? "desc"
        : "";

    setFieldSortOrder(data);
  };

  return (
    <Layout className="page-header-group">
      <Form.Provider>
        <div
          className={`page-header-group--layout ${
            showFilter ? "open-filter" : ""
          }`}
        >
          <Breadcrumb
            className="w-full"
            items={[
              {
                title: t("Hệ thống gợi ý khoá học", "Hệ thống gợi ý khoá học"),
              },
              {
                title: t("Cài đặt Dự đoán, phân tích xu hướng", "Cài đặt Dự đoán, phân tích xu hướng"),
              },
              {
                title: t("Phân tích nội dung đầu vào sinh viên", "Phân tích nội dung đầu vào sinh viên"),
              },
              {
                title: t("Thông tin khoá học", "Thông tin khoá học"),
              },
            ]}
          />
          <div className="table-header--wrapper justify-between">
            <div className="table-header--left">
              <ArrowLeftOutlined
                className="mr-2"
                onClick={() => navigate(-1)}
              />
              <PageHeader title={t("Thông tin khoá học", "Thông tin khoá học")} />
            </div>
            <FilterTable
              searchValue={searchValue}
              dataColumns={dataColumnsInfoCourse}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              checkedList={checkedList}
              listVisible={listVisible}
              setCheckedList={setCheckedList}
              handleChangeInput={handleChangeInput}
            />
          </div>
          <FormFilter
            clearFilter={clearFilter}
            onFinish={handleFinish}
            showFilter={showFilter}
            optionSelectIndustry={optionSelectIndustry}
            optionSelectSchool={optionSelectSchool}
            setDataFilter={setDataFilter}
            dataFilter={dataFilter}
            checkedList={checkedList}
          />
        </div>
        <TableData
          dataTable={documentSystem}
          dataColumns={columnChecked}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          pagination={true}
          loadingTable={loading}
          scroll={{ x: 1300, y: 600 }}
          totalRecords={totalPage}
          handleTableChangeProps={handleTableChange}
        />
      </Form.Provider>
    </Layout>
  );
};

export default InfoCourseList;
